import { render, staticRenderFns } from "./OperatorPresenceBadgeDialog.vue?vue&type=template&id=13689c9a"
import script from "./OperatorPresenceBadgeDialog.vue?vue&type=script&lang=js"
export * from "./OperatorPresenceBadgeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports